
export enum ArrivalDepartureState {

    ReadOnly = 0,
    Arrival = 1,
    Departure = 2,
    ResetArrival = 3

}

export default ArrivalDepartureState;